<template>
  <el-form style="width: 300px;margin: auto" size="small" status-icon :model="info" ref="info"
           :rules="rules">
    <el-form-item prop="desc" label="Description">
      <el-input v-model="info.desc"></el-input>
    </el-form-item>
    <el-form-item align="right">
      <el-button @click="$emit('closeDialog')">Back</el-button>
      <el-button class="el-button--primary" @click="submit()">submit</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'ProductionEdit',
    props: {
      closeDialog: Function,
      chooseItem: Object,
    },
    data () {
      return {
        info: {
          id: 0,
          desc: ''
        },
        rules: {
          desc: [{required: true, message: 'please enter Description!'}],
        }
      }
    },
    created () {
        const {p_id, p_description} =  this.chooseItem
        this.info = {
            id: p_id,
            desc: p_description
        }
    },
    methods: {
      submit () {
        this.$refs["info"].validate((valid) => {
          if (valid) {
            let loading = this.$util.loading()
            this.$api.rootV1.post('/web/production/edit', this.info,
              (res) => {
                this.info = {
                    id: 0,
                    desc: '',
                }
                this.$message.success('Edit Success!')
                loading.close()
                this.$emit('closeDialog')
              },
              (res) => {
                this.$alert(`edit fail!`, 'info', {
                  confirmButtonText: 'confirm',
                  type: 'error',
                  callback: action => {
                    loading.close()
                  }
                })
              }
            )
          } else {
            this.$message.error('Please check the input data!')
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/productionManage/ProductionEdit.vue